<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="16"
    height="16"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="64" height="64" rx="16" fill="url(#nytmanager-mark)" />
    <path
      d="M40 18c-7.7 0-14 6.3-14 14s6.3 14 14 14c2.7 0 5.2-.8 7.3-2.1C44.6 46.4 40.6 48 36.2 48 26.7 48 19 40.3 19 30.8S26.7 13.6 36.2 13.6c4.4 0 8.4 1.6 11.1 4.1C45.2 18.8 42.7 18 40 18z"
      fill="white"
    />
    <path
      d="M42 36.5h11.2c2.1 0 3.8 1.7 3.8 3.8v7.2c0 2.1-1.7 3.8-3.8 3.8H50l-3.2 3.6V51.3h-4.8c-2.1 0-3.8-1.7-3.8-3.8v-7.2c0-2.1 1.7-3.8 3.8-3.8z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="nytmanager-mark"
        x1="4"
        y1="0"
        x2="60"
        y2="64"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6366F1" />
        <stop offset="1" stop-color="#7C3AED" />
      </linearGradient>
    </defs>
  </svg>
</template>
